exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:1280px){.main__wrapper{min-width:100vw}}@media (min-width:768px){.main__wrapper{min-width:100vw}.mt-2{margin-top:0}}@media (max-width:542px){.header__search__filters{width:80%;right:none}.header__filters{width:20%;position:absolute;right:0;top:46px;background:#000;padding:8px 0 10px 12px;border-bottom:1px solid #000}.mr-1{margin-right:0}}", ""]);

// exports
